import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Global from '../store/global-selectors';

/**
 * Hook to determine if the Shopify Ship From filter should be enabled
 * @returns {boolean} true if the seller has at least one active Shopify store
 */
export const useEnableShopifyShipFromFilter = () => {
  const stores = useSelector(Global.selectSellerStores);
  const shopifyMarketplaceId = 14;

  const hasActiveShopifyStore = useMemo(
    () => stores?.some((store) => store.marketplaceId === shopifyMarketplaceId && store.isActive) ?? false,
    [stores],
  );

  return hasActiveShopifyStore;
};
